import * as React from "react";
import { TeeDetails } from "@kalabo/golfsavers-common";
import { Text } from "@uikit";

interface IProps {
  data: TeeDetails;
}

const CourseTees = ({ data }: IProps) => {
  const teeColor = (color: string) => {
    switch (color) {
      case "Black":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-black bg-black"></div>
        );
      case "Blue":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-blue bg-blue"></div>
        );
      case "White":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-black bg-white"></div>
        );
      case "Red":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-red bg-red"></div>
        );

      case "Yellow":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-qualityok bg-qualityok"></div>
        );
      case "Gold":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-orange bg-orange"></div>
        );
      case "Green":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-green bg-green"></div>
        );
      case "Orange":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-orange bg-orange"></div>
        );
      case "Brown":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-brown bg-brown"></div>
        );
      case "Purple":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-purple bg-purple"></div>
        );
      case "Silver":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-silver bg-silver"></div>
        );
      case "Copper":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-copper bg-copper"></div>
        );
      case "Jade":
        return (
          <div className="w-3 h-3 mr-1 rounded-full border border-jade bg-jade"></div>
        );
    }
  };

  if (!data) {
    return null;
  }
  if (!data?.tees || data.tees.length === 0) return null;

  return (
    <div>
      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className=" mb-5"
        color="black90"
      >
        Scorecard Summary
      </Text>
      <table className="w-full">
        <thead className="">
          <tr className="border-b border-grey3">
            <th className="px-[6px] sm:w-[20%] pb-2 text-left">
              <Text size={13} weight="semibold">
                Tee{data?.note && "*"}
              </Text>
            </th>
            <th className="px-[6px] sm:w-[20%] pb-2">
              <Text size={13} weight="semibold" className="text-center">
                Par
              </Text>
            </th>
            <th className="px-[6px] sm:w-[20%] pb-2">
              <Text size={13} weight="semibold" className="text-center">
                Length
              </Text>
            </th>
            <th className="px-[6px] sm:w-[20%] pb-2">
              <Text size={13} weight="semibold" className="text-center">
                CR
              </Text>
            </th>
            <th className="px-[6px] sm:w-[20%] pb-2">
              <Text size={13} weight="semibold" className="text-center">
                SR
              </Text>
            </th>
          </tr>
        </thead>
        <tbody className="text-center">
          {data?.tees?.map((tee, tIdx) => (
            <tr
              key={tIdx}
              className="border border-grey2 border-r-0 border-l-0 border-t-0"
            >
              <td className="py-[10px] px-[10px] text-left">
                <Text
                  size={15}
                  sizeTablet={15}
                  sizeDesktop={15}
                  leading={1.5}
                  color={"black90"}
                  className="mb-0"
                >
                  <div className="inline-flex items-center">
                    {teeColor(tee.tee)}
                    <span>
                      {tee.tee} {tee.ladies && "(W)"}
                    </span>
                  </div>
                </Text>
              </td>
              <td className="py-[10px] px-[5px]">
                <Text
                  size={15}
                  sizeTablet={15}
                  sizeDesktop={15}
                  leading={1.5}
                  color={"black90"}
                  className="mb-0 text-center"
                >
                  {tee.par}
                </Text>
              </td>
              <td className="py-[10px] px-[5px]">
                <Text
                  size={15}
                  sizeTablet={15}
                  sizeDesktop={15}
                  leading={1.5}
                  color={"black90"}
                  className="mb-0 text-center"
                >
                  {tee.length} yds
                </Text>
              </td>
              <td className="py-[10px] px-[5px]">
                <Text
                  size={15}
                  sizeTablet={15}
                  sizeDesktop={15}
                  leading={1.5}
                  color={"black90"}
                  className="mb-0 text-center"
                >
                  {tee.rating}
                </Text>
              </td>
              <td className="py-[10px] px-[5px]">
                <Text
                  size={15}
                  sizeTablet={15}
                  sizeDesktop={15}
                  leading={1.5}
                  color={"black90"}
                  className="mb-0 text-center"
                >
                  {tee.slope_index}
                </Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {data?.note && (
        <Text size={11} color="black60" leading={1.3} className="mt-[10px]">
          {data.note}
        </Text>
      )}
    </div>
  );
};

export default CourseTees;
